export const publicationsData = [
  {
    id: 1,
    title: "AI for Environmental Management: UrbanCool – AI-Driven Responsive Cooling System",
    authors: "Atharv Patil Patki · Paras Chavan · Gayatri Kadam · Vaibhav Patil",
    venue: "2026 IEEE International Conference for Convergence in Computing Technology (I3CTCON)",
    shortVenue: "IEEE I3CTCON 2026",
    venueLink: "https://ieeexplore.ieee.org/xpl/conhome/11506613/proceeding",
    status: "Published · 2026",
    description:
      "An AI-driven responsive cooling system for smart cities. UrbanCool combines machine learning, reinforcement learning, IoT, and real-time environmental data to optimize cooling, reduce energy use by up to 35%, and improve thermal comfort.",
    link: "https://ieeexplore.ieee.org/document/11507747"
  }
];
